import { useTranslation } from "react-i18next";
import { Typography as FoodsTypography } from "@foodpilot/foods";
import { Stack, Typography as MuiTypography } from "@mui/material";
import type { ComponentAppearance } from "src/components/appearance";

type EmptyRowsFallbackProps = {
    message?: string;
    appearance?: ComponentAppearance;
};
export const EmptyRowsFallback = (props: EmptyRowsFallbackProps) => {
    const { t } = useTranslation();
    const isProductUxV2 = props.appearance === "product-v2";
    const Typography = isProductUxV2 ? FoodsTypography : MuiTypography;

    return (
        <Stack minHeight="96px" alignItems="center" justifyContent="center">
            <Typography variant="body1" textAlign="center">
                {props.message ?? t("il_n_y_a_aucun_record_a_afficher")}
            </Typography>
        </Stack>
    );
};
